import React from "react";
// import { FMarketListData } from "../../../data/foreign/mainBoard/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { useAuth } from "../../../data/auth/hooks";
import { useDisplaySecurityEpsTrend } from "../../../data/reports/securityStatistics/hooks/useDisplaySecurityEpsTrend";
import { formatDateFromISO } from "../../../core/util/functions";

export interface DisplaySecurityEPSTrendProps {
	symbol?: string;
}

export const DisplaySecurityEpsTrend: React.FunctionComponent<DisplaySecurityEPSTrendProps> = ({
	symbol,
}) => {
	const epsTrend = useDisplaySecurityEpsTrend(symbol);

	const style = useDisplaySingleEmementStyles();
	const { getString, getDateString, getDateTimeString, getFormatedNumberString, getFormatedNumberString4 } = React.useContext(
		LocalizationContext
	);

	console.log(epsTrend)

	const [auth] = useAuth();

	return (
		<div className={style.root}>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("period")}</span>
				<span className={style.value}>
					{epsTrend?.period
						? getString(epsTrend.period as any)
						: ""}
				</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("estimateDate")}</span>
				<span className={style.value}>
					{formatDateFromISO(epsTrend?.date)}
				</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("currentEstimate")}</span>
				<span className={style.value}> {getFormatedNumberString4(epsTrend?.current_estimate, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("estimate7DaysAgo")}</span>
				<span className={style.value}> {getFormatedNumberString4(epsTrend?.["7_days_ago"], true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("estimate30DaysAgo")}</span>
				<span className={style.value}> {getFormatedNumberString4(epsTrend?.["30_days_ago"], true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("estimate60DaysAgo")}</span>
				<span className={style.value}> {getFormatedNumberString4(epsTrend?.["60_days_ago"], true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("estimate90DaysAgo")}</span>
				<span className={style.value}> {getFormatedNumberString4(epsTrend?.["90_days_ago"], true)}</span>
			</div>

		</div>
	);
};

